module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAcklEQVRYR+2XywqAMAwE3f//6HgSFLRzWMSD02seXSahbDMzsy1OkqziFMP+mPB7AYS4jYdG0F5A9SjAJXydwHlGxz60lz7N/a7/5ZFRgAQkIAEJSEACnxAgT9h6A+yPCf4LyFeXcbTlZX8sRwEu4dsEdqCY7+Eb70q+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/FISHERRECT_N.png
// module id = Y0vi
// module chunks = 18